import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface SeguimientoPlanAccion {
  id?: number;
  id_plan_accion: number;
  fecha_seguimiento: string;
  porcentaje_avance: number;
  responsable_reporta?: number;
  observaciones: string;
  evidencia_url?: string;
  estado?: number | string;
  ResponsableReportaData?: { cedula: string; nombreCompleto: string };
}

@Injectable({ providedIn: "root" })
export class SeguimientoPlanAccionService {
  private apiUrl = `${environment.apiUrl}/api/seguimiento-siniestro-plan-accion`;

  constructor(private http: HttpClient) {}

  getByPlanAccionId(idPlanAccion: number | string): Observable<SeguimientoPlanAccion[]> {
    return this.http
      .get<SeguimientoPlanAccion[]>(`${this.apiUrl}/plan-accion/${idPlanAccion}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  create(payload: SeguimientoPlanAccion): Observable<SeguimientoPlanAccion> {
    return this.http
      .post<SeguimientoPlanAccion>(this.apiUrl, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  update(id: number | string, payload: Partial<SeguimientoPlanAccion>): Observable<SeguimientoPlanAccion> {
    return this.http
      .put<SeguimientoPlanAccion>(`${this.apiUrl}/${id}`, payload, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }

  delete(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError((error) => throwError(() => error)));
  }
}